// latest: hansong 2017-2-21 4:25 PM
import { Model } from 'common'
Model.define('model.notice', {
  proxy: {
    get: '/cpu-supplymgr/notice/oneNotice',
    post: '/cpu-supplymgr/supplyApply/updateSupplyApplyByConditon'
  },
  meta: {
    applyDate: '',
    noticeName: '',
    noticeCode: '',
    typeId: '',
    id: '',
    status: '',
    noticeValue: '',
    enterpriseId: ''
  }
})

export default Model.create('model.notice')



// WEBPACK FOOTER //
// ./src/data/model/notice/index.js